// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectTradingSignalCancelMessage } from '@shared/utils/DirectMessages/DirectTradingSignalCancelMessage';
export class TradingSignalCancelMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectTradingSignalCancelMessage();
        const len = fieldSet.Count();
        for (let i = 0; i < len; i++) {
            const fixField = fieldSet.fieldSet[i];
            if (fixField.FieldId === 0) {
                continue;
            }
            if (fixField.FieldId === FieldsFactory.FIELD_TRADING_SIGNAL_ID) {
                message.TradingSignalId = fixField.Value;
            }
        }
        return [message];
    }
}
